export const en = {
  'Log Out': 'Log Out',
  'Properties': 'Properties',
  'Fields': 'Fields',
  'Save Form': 'Save Form',
  'Duplicate Form':'Duplicate Form',
  'Assignments':'Assignments',
};
